// extracted by mini-css-extract-plugin
export default {"container":"ZD-z","dimension":"_D-z","dimensionLabels":"aE-z"};